import {
  PARTNERS_LOAD_REQUEST,
  PARTNERS_LOAD_SUCCESS,
  PARTNERS_LOAD_FAILURE,
  PARTNERS_ADD_PARTNER,
  PARTNERS_UPDATE_PARTNER
} from '../types/partners-type';

const initialState = {
  loading: false,
  error: null,
  partners: []
};

function partners(state = initialState, action: any = null) {
  switch (action.type) {
    case PARTNERS_LOAD_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case PARTNERS_LOAD_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };

    case PARTNERS_LOAD_SUCCESS:
      return {
        ...state,
        partners: action.payload,
        loading: false,
        error: null
      };

    case PARTNERS_ADD_PARTNER:
      return {
        ...state,
        partners: [action.payload, ...state.partners]
      };

    case PARTNERS_UPDATE_PARTNER:
      return {
        ...state,
        partners: state.partners.map((partner: any) => {
          return partner.id === action.partner.id ? action.partner : partner;
        })
      };

    default:
      return state;
  }
}

export default partners;
